import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import * as Papa from 'papaparse';

export default function URLRedirect() {

    const { urlId } = useParams();

    useEffect(() => {

        fetch('/url-redirects.csv?nocache=' + Date.now())
            .then(response => response.text())
            .then(responseText => {

                const data = Papa.parse(responseText, { header: true });

                const rows = data.data.filter(row => row.id);

                const match = rows.find(row => row.id === urlId);

                if (match && match.to) {
                    window.location.replace(match.to);
                } else {
                    window.location.replace('/404');
                }

            });

    }, [urlId]);

    return <div>Doorverwijzen...</div>;
}